import { SDKResponse } from '@commercetools/frontend-sdk';
import { ProjectSettings } from 'shared/types/ProjectSettings';
import useSWRImmutable from 'swr/immutable';
import { sdk } from 'sdk';

const useProjectSettings = () => {
  const response = useSWRImmutable<SDKResponse<ProjectSettings>>('/action/project/getProjectSettings', () =>
    sdk.composableCommerce.project.getSettings(),
  );

  const projectSettings = response.data?.isError ? {} : response.data?.data;

  return { ...response, projectSettings };
};

export default useProjectSettings;
